import React from "react";
import styled from "styled-components";

const NoQuotesDiv = styled.div`
  margin-top:8px;
  background:#f2f2f2;
  padding:12px
  color:#999999;  
  font-size: 17px;
`;
const NoQuotes = props => (
  <NoQuotesDiv>There are no quotes for this deal</NoQuotesDiv>
);
export default NoQuotes;
